import { FormControl, FormHelperText, InputLabel, Checkbox, Select, MenuItem, ListItemText } from "@mui/material"
import { FieldRenderProps } from "react-final-form";
import { SelectOption } from "../SelectField";

export type CheckboxFieldProps = FieldRenderProps<String[], any> & Props;
type Props = {
    label: string;
    options: SelectOption[];
    required?: boolean;
    placeholder?: string;
};
export type MultiSelectOption = {
    label: string;
    value: string;
}
const MultiSelectField: React.FC<CheckboxFieldProps> = ({ input, meta, loading, options, helperText, ...props }) => {
    const { invalid, touched, error, submitError } = meta;
    const hasError = invalid && touched;
    return (
        <FormControl fullWidth error={hasError}>
            <InputLabel required={props.required}>{props.label}</InputLabel>
            <Select
                multiple
                value={input.value || []}
                onChange={(e) => input.onChange(e.target.value)}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                // required={props.required}
                renderValue={(selected) =>
                    selected
                        .map(
                            (value) =>
                                options.find((o) => o.value === value)?.label
                        )
                        .join(", ")
                }
                {...props}
            >
                {options.map((option: MultiSelectOption) => (
                    <MenuItem key={option.value} value={option.value}>
                        <Checkbox checked={(input.value || []).includes(option.value)} />
                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}
            </Select>
            {hasError && (
                <FormHelperText>
                    {error || submitError}
                </FormHelperText>
            )}
        </FormControl>
    )
}
export default MultiSelectField